import { API_PATH } from '../../routes/generalPath';

export const ENQUETE_CREATE_PATH = {
  CREATE: API_PATH.ENQUETE_CREATE + '/create',
  EDIT: API_PATH.ENQUETE_CREATE + '/edit',
  SEND_RESPONSE_REQUEST: API_PATH.ENQUETE_CREATE + '/send-response-request',
};
